/**
 * Public entry point for the headless 1auth SDK.
 *
 * Exposes {@link OneAuthHeadlessClient} plus the request/response types
 * an integrating app needs when using its own ERC-7579 validator (e.g.
 * the experimental SmartSession from `@rhinestone/sdk`) to sign intents
 * locally instead of going through the passkey dialog.
 */

export { OneAuthHeadlessClient } from "./headless-client";
export {
  buildSmartSessionHeadlessSignatures,
  type BuildSmartSessionHeadlessSignaturesOptions,
} from "./smart-session-signatures";

export type {
  HeadlessIntentStatusResult,
  HeadlessIntentOptions,
  HeadlessPrepareResult,
  HeadlessSubmitOptions,
  HeadlessSubmitResult,
  InstallSmartSessionOptions,
  InstallSmartSessionResult,
  SessionKeyHandle,
  SmartSessionEnableRequest,
} from "./types";
